import React from 'react';
import { Modal, Paper } from '@mui/material';
import AnswerMissionDeconflictionLayout from '../layouts/AnswerMissionDeconflictionLayout';
import {Deconfliction} from "../../../classes/Deconfliction";
import {Mission} from "../../../classes/Mission";

function AnswerMissionDeconflictionModal(props: {
    deconflictionData: Deconfliction,
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function
}) {
    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <AnswerMissionDeconflictionLayout
                    title="Answer Deconfliction"
                    initInfo={props.deconflictionData}
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default AnswerMissionDeconflictionModal;